import { Component, ViewChild } from '@angular/core';
import { NavController,AlertController, App,Config,Platform ,Slides   } from 'ionic-angular';
import { HomeSetPage } from '../homeset/homeset';
import { HttpService } from '../../../providers/service/httpservice';
import { HOME_SLIDES,HOME_NEWS,HOME_REC_APPS,HOME_COLL_APPS, HOME_YKT_YE} from '../../../providers/config/serviceurl';
import { BrowserPage } from '../../comm/browser/browser';
import { NewsListPage } from '../news/list/list';
import {SearchPage} from '../../commonsearch/search/search';
import { NewsDetail } from '../news/detail/detail';
import { AppState } from '../../../app/app.global';
import { LoginPage } from '../../login/login/login';
import { StorageService } from '../../../providers/service/storageservice';
import { CardQueryPage } from '../../application/life/card/cardquery';
import { BooksOverview } from '../../application/life/books/overview/mybooks';
import { HelpCenter } from '../../application/dailyoffice/helpcenter/overview/helpcenter';
import { UnifiedAddressBookList } from '../../application/dailyoffice/unifiedaddressbook/list/unifiedaddressbooklist';
import { ClassSchedule } from '../../application/teaching/classschedule/classschedule';
import { ElectiveResult } from '../../application/teaching/elective/electiveresult';
import { ScoreQueryPage } from '../../application/teaching/score/scorequery';
import { FreeClassroom } from '../../application/teaching/freeclassroom/freeclassroom';
import { ProjectList } from '../../application/research/project/list/projectlist';
import { ProjectFundingList } from '../../application/research/profunding/list/list';
import { ThesisList } from '../../application/research/thesis/list/list';
import { ProductionList } from '../../application/research/production/list/list';
import { CopyrightList } from '../../application/research/copyright/list/list';
import { SalaryInquiry } from '../../application/finance/salary/salaryinquiry';
import { ReportList } from '../../application/research/report/list/list';
import { PrizeList } from '../../application/research/prize/list/list';
import { IdentificationList } from '../../application/research/identification/list/list';
import { PatentList } from '../../application/research/patent/list/list';
import { AppointInfo } from '../../application/personnel/appoint/appointinfo/appointinfo';
import { FRZSQ} from '../../../providers/config/serviceurl';
import { YZSQ} from '../../../providers/config/serviceurl';
import { XZSQSQ} from '../../../providers/config/serviceurl';
import { SSKTSQ} from '../../../providers/config/serviceurl';
import { JSQKDRWSQ} from '../../../providers/config/serviceurl';
import { Utils} from '../../../providers/service/utils';
import { SERVICE_YKT_URL,SERVICE_TSJY_URL,SERVICE_KBCX_URL,THIRD_APP_JUMP,SERVICE_YKT_CODE, SERVICE_TSJY_CODE, SERVICE_KBCX_CODE,TSJYCX_BORROWNUM_URL, SELECT_MSG_CATEGORY, KBCX_IMPORTANCE_NOTICE_URL, UNREAD_MAIL_MOUNT_URL,MAIL_URL,HOME_LIST,SELECT_MSGLIST_URL,CHECK_BIND_MAIL} from '../../../providers/config/serviceurl';
import {MessageListPage} from '../../../pages/message/list/list';
import {TabsPage} from '../../tabs/tabs/tabs';
import { BindEmailPage } from '../../login/email/bind/bindEmail';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';



@Component({
  selector: 'home-page',
  templateUrl: 'home.html'
})
export class HomePage{
  @ViewChild(Slides) slides: Slides;
  public isShowBottomTip:any = 'false';
  popularNews:any[];
  rotationNews:any[];
  serviceItems:any[];
  currentUser:any;
  user:any={};
  resourceUrl:any;//资源url；

  public list:any = [];
  public homeList:any = [];
  public firstList:any= [];

  public myServeList:any;//我的服务列表
  public recommendServeList:any;//推荐服务列表
	terrace:any;//判断是ios还是android

	borrowBookNum:any=0;//在借图书数量
	yktRemainMoney:any=0;//一卡通余额
	dbMsgNum:any=0;//待办消息数量
	kbNotice=[];//课表查询
	unreadMailNum:any=0;//未读邮箱数量
	private mailUrl:any;//邮件单点登录地址

  constructor(public navCtrl: NavController,public appCtrl: App,public global: AppState ,private platform: Platform,
	private httpService:HttpService,private alertCtrl: AlertController,private config:Config, private inAppBrowser:InAppBrowser) {
		//登录后禁止左滑到登录页面
		this.config.set("ios", "swipeBackEnabled", "false");
		this.user = StorageService.getObj('currentUser');
		this.resourceUrl = StorageService.getObj('resourceUrl');
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
			this.gotoLoginPage();
		}
		//打包wap访问时注释下面判断方法
		//判断是ios还是android
		if (this.platform.is('ios')) {
			this.terrace = '26px';
		} else if (this.platform.is('android')) {
		}

  }
  //当将要进入页面时触发
  ionViewWillEnter(){
		if(this.user!=null&&this.user!=""&&this.user.userId!=null&&this.user.userId!='undefined'&&this.user.userId!=''){
			this.dataInit();
		}
	}

	isNavToBindEmailPage() {
        let params = { accountKey: Utils.base64Encode(this.user.username) };
		this.httpService.get2(CHECK_BIND_MAIL, params).then(data =>{
			if (!data || !data.data || data.data.bindMail != '1') {
				this.navCtrl.push(BindEmailPage,{});
			}
		});
	}

	ionViewDidLeave(){
		this.slides.stopAutoplay();
	}

	slideStop(){
		this.slides.startAutoplay();
	}

	dataInit(){
		this.homeList = [];
		this.firstList = [];
		this.list = [];
		this.isNavToBindEmailPage(); // 是否绑定邮箱
		this.getRotationNews();//获取幻灯片
		this.getMyServeList();//获取我的服务
		this.getrecommendServeList();//获取推荐服务
		this.getPopularNews();//获取新闻通知

		this.getYktRemainMoney();//获取一卡通账户余额
		this.getTsjyBorrowNum();//获取图书借阅在借数量
		this.getMsgTypes();//获取待办消息数量
		this.getKbImportanceNotice();//获取今日课表重要通知
		this.getUnreadMailAmount();//获取未读邮件数量
		this.getMailUrl();//获取邮件单点登录地址
		this.getHomeList();
	}

	/**
	 * 卡片栏目
	 */
  getHomeList(){
    let params = {'username':this.user.xgh};
	this.httpService.get2(HOME_LIST,params).then(anyObj =>this.handleHomeList(anyObj));
  }

  handleHomeList(obj:any){
     if(obj){
		 let list = obj.items;
		 //固定的放上面（幻灯片）
         for(let i=0;i<list.length;i++){
			 if(list[i].fixed){
				let obj = {'name':list[i].name,'code':list[i].code,'status':0};
				this.firstList.push(obj);
			 }else{
				let obj = {'name':list[i].name,'code':list[i].code,'status':0};
				this.homeList.push(obj);
			 }
		 }
	 }
	 if(localStorage['homeSet']==undefined || localStorage['homeSet']=="" || JSON.parse(localStorage.getItem('homeSet')).length < 1){
		 //没有缓存的情况
		this.list = this.homeList;

	}else{
		let arr = [];
		//有缓存的情况
		let homeSetList = JSON.parse(localStorage.getItem('homeSet'));
		//先取出缓存内的按排序展示
		for(let j=0;j<homeSetList.length;j++){
		    for(let i=0;i<this.homeList.length;i++){
				if(homeSetList[j].code == this.homeList[i].code){
					this.list.push(homeSetList[j]);
					arr.push(i);
				}
			}
		}
		let max;
		for(var i=0; i<arr.length; i++){
		　//外层循环一次，就拿arr[i] 和 内层循环arr.legend次的 arr[j] 做对比
			for(var j=i; j<arr.length; j++){
				if(arr[i]<arr[j]){
				//如果arr[j]大就把此时的值赋值给最大值变量max
			　　　　max=arr[j];
				   arr[j]=arr[i];
				   arr[i]=max;
				}
			}
		}
		for(let i=0;i<arr.length;i++){
			this.homeList.splice(arr[i],1);
		}
		// //去除homelist内已经与缓存重复的
		// for(let i=0;i<this.homeList.length;i++){
		// 	for(let j=0;j<homeSetList.length;j++){
		// 		if(homeSetList[j].code == this.homeList[i].code){
		// 			this.homeList.splice(i,1);
		// 		}
		// 	}
		// }
		//剩下的接在后面
		for(let i=0;i<this.homeList.length;i++){
				this.list.push(this.homeList[i]);
		}
	}

  }


  getrecommendServeList(){
	let params = {'username':this.user.xgh};
	this.httpService.get2(HOME_REC_APPS,params).then(anyObj =>this.handleRecommendServes(anyObj));
  }

  //推荐服务
  handleRecommendServes(obj:any){
	if(obj){
		// this.recommendServeList = JSON.parse(obj).items;
		this.recommendServeList = obj.items;
		for(let i =0;i<this.recommendServeList.length;i++){
			if(this.recommendServeList[i].SERVICE_PIC_ID){
				this.recommendServeList[i].SERVICE_PIC_ID = this.resourceUrl+"/"+this.recommendServeList[i].SERVICE_PIC_ID;
			}
		}
	}
  }

//我的服务
getMyServeList(){
	let params = {'username':this.user.xgh,'pageNo':0,'pageSize':10,'loadAll':false};
	this.httpService.get2(HOME_COLL_APPS,params).then(anyObj =>this.handleCollectServes(anyObj));
}

handleCollectServes(obj:any){
	if(obj){
		this.myServeList = obj.items;
		for(let i =0;i<this.myServeList.length;i++){
			if(this.myServeList[i].SERVICE_PIC_ID){
				this.myServeList[i].SERVICE_PIC_ID = this.resourceUrl+"/"+this.myServeList[i].SERVICE_PIC_ID;
			}
		  }
	}
}

gotoServe(event:any, item:any){
	let colorTheme = this.global.colorTheme;
    if(colorTheme != null && colorTheme != undefined && colorTheme.length > 4){
      colorTheme = '#' + colorTheme.substring(5,colorTheme.length);
	}
	console.dir(item);
	if(item != null && item != undefined){
		let o = item.SERVICE_APP_SUBSERVICE;
		if(o != null && o != undefined && o !=''){
		   let title = o[0].SUBSERVICE_NAME;
		   let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
		   let flag = "thirdApp";
		   if(url.indexOf(flag) != -1){
			  this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_blank','location=yes');
		   }else{
			this.httpService.openOuterLink(title, url,colorTheme);
		   }
		}
	  }
}

urlencode (str) {
    str = (str + '').toString();
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}



goTorecommendServe(event:any, item:any){
	if(item.code == "tytxl"){//通讯录
		this.appCtrl.getRootNav().push(UnifiedAddressBookList);
	}else if(item.code == "bzzz"){//帮助中心
		this.appCtrl.getRootNav().push(HelpCenter);
	}else if(!this.user || this.user.userId=='undefined' || this.user.userId==null || this.user.userId==''){
		this.gotoLoginPage();
	}else if(item.code == "kbcx"){//课程表
		this.appCtrl.getRootNav().push(ClassSchedule);
	}else if(item.code == "cjcx"){//成绩查询
		this.appCtrl.getRootNav().push(ScoreQueryPage);
	}
}


  getRotationNews(){
	let params = {'username':this.user.xgh};
	this.httpService.get2(HOME_SLIDES,params).then(anyObj =>this.handleRotationNews(anyObj));

  }
  handleRotationNews(obj:any){
  	if(obj){
		this.rotationNews=obj.items;
	}
  }
  getPopularNews(){//主页新闻
	let params = {'username':this.user.xgh,'pageNo':0,'pageSize':3,'columnId':'8a8a88fa71a6412a0171aab5f6c2000d'};
	  this.httpService.get2(HOME_NEWS,params).then(anyObj =>this.handlePopularNews(anyObj));
  }
  handlePopularNews(obj:any){
  	if(obj){
		// this.popularNews=JSON.parse(obj).items;
		this.popularNews=obj.items;
	}
  }

  openItemDetail(event:any, item:any){
  		// this.appCtrl.getRootNav().push(NewsDetail,item);
      if(item!=null&&item!='undefined'&&item!=''
      	&&item.link!=null&&item.link!='undefined'&&item.link!=''){
      	this.appCtrl.getRootNav().push(BrowserPage,{
      				browser: {title: item.title, url: item.link}});
      				window.open(item.link);
      }else{
      	this.appCtrl.getRootNav().push(NewsDetail,item);
      }
  }
  openItemDetail2(event:any, item:any){
	if(item.fileUrl&&item.fileUrl!=null){
	  this.appCtrl.getRootNav().push(NewsDetail,item);
	}
 }
  openSearchPage(){
  	this.appCtrl.getRootNav().push(SearchPage);
	}

	homeSetCallback = (params)=>{

		return new Promise((resolve, reject) => {
      if(typeof(params)!='undefined'){
          resolve('ok');
					this.dataInit();
      }else{
          reject(Error('error'))
      }
   });

	}

  openHomeSetPage(){
		if(this.user&&this.user.userId!=null&&this.user.userId!=''&&this.user.userId!='undefined'){
			this.appCtrl.getRootNav().push(HomeSetPage,{callback: this.homeSetCallback,firstList:this.firstList,list:this.list});
		}else{
			this.gotoLoginPage();
		}
  }

  openNewsList(){
  	this.appCtrl.getRootNav().push(NewsListPage);
  }

  //上拉加载
  loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
  //下拉刷新
  doRefresh(refresher){
	  this.dataInit();
      setTimeout(() => {
			this.isShowBottomTip= 'true';
			refresher.complete();
      }, 3500);
  }

  //跳转登录页面
  gotoLoginPage(){
	  this.appCtrl.getRootNav().setRoot(LoginPage);
  }

  /**优化1.1版本添加一卡通余额 */
  getYktRemainMoney(){
	let xgh = Utils.getRSAData(this.user.xgh);
	let params = {'userId':xgh};
	this.httpService.get2(HOME_YKT_YE,params).then(anyObj =>this.handleRemainMoney(anyObj));
	// this.httpService.get2("http://192.168.0.51:8207/api/v1/yktxf/getYktRemainMoneyByXgh",params).then(anyObj =>this.handleRemainMoney(anyObj));
  }

  handleRemainMoney(obj:any){
	  if(obj != null && obj !=undefined && obj.remainMoney != null && obj.remainMoney != undefined ){
			this.yktRemainMoney = obj.remainMoney;
	  }
	}

	/**打开一卡通 */
	openYktServicePage(){
		//this.gotoServiceByCode(SERVICE_YKT_CODE);
		this.gotoServiceByUrl(SERVICE_YKT_URL);
	}

	/**根据servicecode打开内置服务页面 */
	// gotoServiceByCode(serviceCode:any){
	// 	console.dir(this.myServeList);
	// 	let myServeList = this.myServeList;
	// 	if(this.myServeList && myServeList.constructor == Array){
	// 		console.log("inner myServeList="+ myServeList);
	// 		for(let item of myServeList){
	// 		 let s = item.appUrl;
	// 	     if(s != null && s != undefined && s !=''){
	// 	       let o = JSON.parse(s);
	// 	       console.log( o.url[0].name + o.url[0].url);
	// 	       let title = o.url[0].name;
	// 		   let url =  o.url[0].url;
	// 		   if(url && url.indexOf('mobileServiceCode='+ serviceCode) != -1){
	// 			 this.httpService.openOuterLink(title, url,"");
	// 		     break;
	// 		   }
	// 	   }
	// 	  }
	// 	}
	// }

	gotoServiceByUrl(serviceUrl:any){
		this.httpService.openOuterLink('', serviceUrl,'');

	}
	gotoServiceByCode(serviceCode:any){
		console.dir(this.myServeList);
		let myServeList = this.myServeList;
		if(myServeList && myServeList.constructor == Array){
			console.log("inner myServeList="+ myServeList);
			for(let i=0; i< myServeList.length; i++){
				let item  = myServeList[i];
				let o = item.SERVICE_APP_SUBSERVICE;
				if(o != null && o != undefined && o !=''){
				   let title = o[0].SUBSERVICE_NAME;
				   let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
					// let flag = "thirdApp";
					// if(url.indexOf(flag) != -1){

					//  this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_self','location=yes');
					// }else{
						//判断url包含服务对应的code则打开
						if(url.indexOf("mobileServiceCode="+serviceCode) != -1){
						   this.httpService.openOuterLink(title, url,'');
						}
					// }
				   }



			 }

		}
	}




	/**优化1.1版本，添加在借图书数量 */
  getTsjyBorrowNum(){
	let xgh = Utils.getRSAData(this.user.xgh);
		let params = {'userId':xgh};
		this.httpService.get2(TSJYCX_BORROWNUM_URL,params).then(anyObj =>this.handleTsjyBorrowNum(anyObj));
	}

	handleTsjyBorrowNum(obj:any){
			if(obj != null && obj !=undefined && obj.count != null && obj.count != undefined ){
				this.borrowBookNum = obj.count;
			}
		}

	/**打开图书借阅服务 */
	openTsJyServicePage(){
		//this.gotoServiceByCode(SERVICE_TSJY_CODE);
		this.gotoServiceByUrl(SERVICE_TSJY_URL);
	}

	/**获取待办消息 */
	getMsgTypes(){
		let params = {'username':this.user.xgh,'code':'02',typeName:' ',pageNo:0,pageSize:10};
		this.httpService.get2(SELECT_MSGLIST_URL,params).then(anyObj =>this.handlegetMsgTypes(anyObj));
	}

	handlegetMsgTypes(obj:any){
		if(obj){
			// let msgTypes = obj.items;

			// if(msgTypes != null && msgTypes != undefined){
			// 	for (let i = 0; i < msgTypes.length; i++) {
			// 		//CODE为02表示待办消息
			// 		if(msgTypes[i].CODE == '02'){
			// 			if(msgTypes[i].count > 99){//大于99则显示99
			// 				this.dbMsgNum = 99;
			// 			}else{
			// 				this.dbMsgNum = msgTypes[i].count;
			// 			}
			// 			break;
			// 		}
			// 	}
			// }
			// let msgTypes = obj.totalItems;
			// if(msgTypes > 99){
			// 	this.dbMsgNum = 99;
			// }else{
			// 	this.dbMsgNum = msgTypes;
			// }

			let itemList = obj.items;
			let msgTypes = 0;
			for(var i = 0;i < itemList.length;i++){
				if(itemList[i].handle == false){
					msgTypes = msgTypes + 1;
				}
			}
			if(msgTypes > 99){
				this.dbMsgNum = 99;
			}else{
				this.dbMsgNum = msgTypes;
			}

		}

	}

	/**打开消息tab页 */
	openMsgListPage(){
	    //const MsgPageTabIndex = 2;//消息tab的索引
		//this.navCtrl.parent.select(MsgPageTabIndex);

		this.appCtrl.getRootNav().push(MessageListPage);

	}

	/**获取重要通知--课表信息 */
	getKbImportanceNotice(){
		let date = new Date();
		let month = ''+(date.getMonth()+1);
		if((date.getMonth()+1)<10){
           month = '0'+month;
		}
		let day = ''+date.getDate();
        if(date.getDate()<10){
			day = '0'+day;
		}
		let dateStr = '' + date.getFullYear() + month + day;
		// dateStr = "20180724";//TODO
		let xgh = Utils.getRSAData(this.user.xgh);
		let params = {'userId':xgh, 'dateStr':dateStr,'role':this.user.role};
		this.httpService.get2(KBCX_IMPORTANCE_NOTICE_URL,params).then(anyObj =>this.handleKbcxNotice(anyObj));
	}

	handleKbcxNotice(obj:any){
		if(obj != null && obj !=undefined ){
			this.kbNotice = obj;
		}
	}

	/**打开课表服务页 */
	openKbPage(){
	//	this.gotoServiceByCode(SERVICE_KBCX_CODE);
		this.gotoServiceByUrl(SERVICE_KBCX_URL);
	}

	/**获取未读邮件数量 */
	getUnreadMailAmount(){
		let params = {'userId':this.user.xgh};
		this.httpService.get2(UNREAD_MAIL_MOUNT_URL,params).then(anyObj =>this.handleUnreadMailAmount(anyObj));
	}

	handleUnreadMailAmount(obj:any){
		if(obj != null && obj !=undefined ){
			this.unreadMailNum = obj.count;
		}
	}

	/**获取单点登录地址 */
	getMailUrl(){
		let params = {'userId':this.user.xgh};
		this.httpService.get2(MAIL_URL,params).then(anyObj =>this.handToMailUrl(anyObj));
	}

	handToMailUrl(obj:any){
		if(obj != null && obj !=undefined ){
			this.mailUrl = obj.url;
		}
	}

	/**跳转单点登录地址 */
	toMailUrl(){
		let colorTheme = this.global.colorTheme;
		if(colorTheme != null && colorTheme != undefined && colorTheme.length > 4){
			colorTheme = '#' + colorTheme.substring(5,colorTheme.length);
		}
		this.httpService.openOuterLink("邮箱单点登录", this.mailUrl,colorTheme);
	}

}



// WEBPACK FOOTER //
// ./src/pages/home/home/home.ts